import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class BlogCategory extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/BlogCategory/BlogCategoryBrowser.js")
	}

	render() {
		return (
			<Activity 
				name="BlogCategory"
				RenderedComponent={this.RenderedComponent}
				context="BlogCategory"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(BlogCategory)
